var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.154 3.35304L0 4.50704V6.88604L1.154 8.04004C1.363 8.24904 1.702 8.24904 1.911 8.04004L3.876 6.07504C4.085 5.86604 4.085 5.52704 3.876 5.31804L1.911 3.35304C1.702 3.14404 1.363 3.14404 1.154 3.35304Z",
    fill: "#799088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04004 1.154L6.88604 0H4.50704L3.35304 1.154C3.14404 1.363 3.14404 1.702 3.35304 1.911L5.31804 3.876C5.52704 4.085 5.86604 4.085 6.07504 3.876L8.04004 1.911C8.24904 1.702 8.24904 1.363 8.04004 1.154Z",
    fill: "#799088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2391 8.04004L11.3931 6.88604V4.50704L10.2391 3.35304C10.0301 3.14404 9.6911 3.14404 9.4821 3.35304L7.5171 5.31804C7.3081 5.52704 7.3081 5.86604 7.5171 6.07504L9.4821 8.04004C9.6911 8.24904 10.0301 8.24904 10.2391 8.04004Z",
    fill: "#799088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.cff8555f75c496806802facf3cbab6f5.svg";
export { ForwardRef as ReactComponent };